import { Navigate } from "react-router";

import { useWhoami } from "@/auth/use-whoami";
import { ErrorState } from "@/components/ErrorState";
import { Skeleton } from "@/components/ui/skeleton";
import { NAV_ITEMS } from "@/lib/nav";
import { ForbiddenPage } from "@/pages/ForbiddenPage";

export function HomeRedirect() {
  const { data, isPending, isError, error, refetch } = useWhoami();

  if (isPending) {
    return <Skeleton className="h-64 w-full" />;
  }
  if (isError) {
    return <ErrorState error={error} onRetry={() => void refetch()} />;
  }

  // NAV_ITEMS is NAV_SECTIONS flattened in sidebar order, pinned block first,
  // so this is "the topmost sidebar entry this role can open".
  const firstVisiblePage = NAV_ITEMS.find((item) =>
    data.permissions.includes(item.permission),
  );
  if (!firstVisiblePage) return <ForbiddenPage />;

  return <Navigate to={firstVisiblePage.to} replace />;
}
